// DO NOT MODIFY - generated by `rake intl:compile_page[<scope>]` from every page surface's
// config/locales/<scope>/*.yml. Edit those files and re-run instead.
export const LOADERS: Record<string, () => Promise<unknown>> = {
  ar: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-ar" */ 'js/i18n/page_translations/liswp_blocks/ar.wjs'),
    ]),
  bn: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-bn" */ 'js/i18n/page_translations/liswp_blocks/bn.wjs'),
    ]),
  cs: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-cs" */ 'js/i18n/page_translations/liswp_blocks/cs.wjs'),
    ]),
  da: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-da" */ 'js/i18n/page_translations/liswp_blocks/da.wjs'),
    ]),
  de: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-de" */ 'js/i18n/page_translations/liswp_blocks/de.wjs'),
    ]),
  el: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-el" */ 'js/i18n/page_translations/liswp_blocks/el.wjs'),
    ]),
  es: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-es" */ 'js/i18n/page_translations/liswp_blocks/es.wjs'),
    ]),
  fa: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-fa" */ 'js/i18n/page_translations/liswp_blocks/fa.wjs'),
    ]),
  fi: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-fi" */ 'js/i18n/page_translations/liswp_blocks/fi.wjs'),
    ]),
  fr: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-fr" */ 'js/i18n/page_translations/liswp_blocks/fr.wjs'),
    ]),
  he: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-he" */ 'js/i18n/page_translations/liswp_blocks/he.wjs'),
    ]),
  hi: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-hi" */ 'js/i18n/page_translations/liswp_blocks/hi.wjs'),
    ]),
  hu: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-hu" */ 'js/i18n/page_translations/liswp_blocks/hu.wjs'),
    ]),
  id: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-id" */ 'js/i18n/page_translations/liswp_blocks/id.wjs'),
    ]),
  it: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-it" */ 'js/i18n/page_translations/liswp_blocks/it.wjs'),
    ]),
  ja: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-ja" */ 'js/i18n/page_translations/liswp_blocks/ja.wjs'),
    ]),
  ko: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-ko" */ 'js/i18n/page_translations/liswp_blocks/ko.wjs'),
    ]),
  nl: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-nl" */ 'js/i18n/page_translations/liswp_blocks/nl.wjs'),
    ]),
  no: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-no" */ 'js/i18n/page_translations/liswp_blocks/no.wjs'),
    ]),
  pa: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-pa" */ 'js/i18n/page_translations/liswp_blocks/pa.wjs'),
    ]),
  pl: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-pl" */ 'js/i18n/page_translations/liswp_blocks/pl.wjs'),
    ]),
  pt: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-pt" */ 'js/i18n/page_translations/liswp_blocks/pt.wjs'),
    ]),
  ro: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-ro" */ 'js/i18n/page_translations/liswp_blocks/ro.wjs'),
    ]),
  ru: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-ru" */ 'js/i18n/page_translations/liswp_blocks/ru.wjs'),
    ]),
  sr: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-sr" */ 'js/i18n/page_translations/liswp_blocks/sr.wjs'),
    ]),
  sv: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-sv" */ 'js/i18n/page_translations/liswp_blocks/sv.wjs'),
    ]),
  tr: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-tr" */ 'js/i18n/page_translations/liswp_blocks/tr.wjs'),
    ]),
  uk: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-uk" */ 'js/i18n/page_translations/liswp_blocks/uk.wjs'),
    ]),
  vi: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-vi" */ 'js/i18n/page_translations/liswp_blocks/vi.wjs'),
    ]),
  zh: () =>
    Promise.all([
      import(/* webpackChunkName: "page-i18n-zh" */ 'js/i18n/page_translations/liswp_blocks/zh.wjs'),
    ]),
};
// a8e7ee95a93c1c7a81dd7e5724d992fa
